export default __webpack_public_path__ + "static/eh-ef476bcfe2a2d45151a185d6020847a0.svg";